import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';

import { provideTranslateService, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { TRANSLATE_HTTP_LOADER_CONFIG, TranslateHttpLoader } from '@ngx-translate/http-loader';
import { firstValueFrom } from 'rxjs';

export const SOURCE_LOCALE = 'en';

export function provideAppI18n(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: TRANSLATE_HTTP_LOADER_CONFIG,
      useValue: {
        prefix: '/i18n/',
        suffix: '.json',
      },
    },
    ...provideTranslateService({
      fallbackLang: SOURCE_LOCALE,
      loader: {
        provide: TranslateLoader,
        useClass: TranslateHttpLoader,
      },
    }),
    provideAppInitializer(() => {
      const translateService = inject(TranslateService);

      return firstValueFrom(translateService.use(SOURCE_LOCALE));
    }),
  ]);
}
